import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';
import { SCROLL_OFFSET, SCROLL_DURATION } from 'site-modules/shared/constants/sub-navigation';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { Element } from 'react-scroll'; // eslint-disable-line no-restricted-syntax
import { Link } from 'site-modules/shared/components/link/link';
import { transformContentForFaq } from 'site-modules/shared/components/faq/utils';
import { WRAPPER_TYPES } from 'site-modules/shared/components/faq/constants';
import { Faq } from 'site-modules/shared/components/faq/faq';

import './more-info-section.scss';

const CLASSES_MAP = {
  h2: 'heading-3',
  h3: 'heading-4',
  h4: 'heading-5',
};

const addClassesToHtmlElement = (htmlStr, classesMap) => {
  let styledHtml = htmlStr;
  Object.keys(classesMap).forEach(element => {
    styledHtml = styledHtml.replace(new RegExp(`<${element}>`, 'g'), `<${element} class="${classesMap[element]}">`);
  });
  return styledHtml;
};

export function MoreInfoSection({
  content = DEFAULT_CONTENT,
  faqContent = DEFAULT_CONTENT,
  pathname = '',
  className = '',
}) {
  const html = content.metadata('content').value();
  const styledContent = addClassesToHtmlElement(html, CLASSES_MAP);

  return (
    <div className={classnames('text-gray-darker more-info', className)}>
      <ContentCollapse
        textClosed="Read more"
        textOpen="Read less"
        justify="justify-content-start"
        btnContainerClasses="mt-0_5 pb-0"
        btnClasses="px-0_5 pt-0_5 pb-0 size-16 text-primary-darker more-info-btn"
        btnTextClasses="fw-normal"
        minHeight="300px"
        showBtnBelow
        isEclipseFade={false}
        resetParams={{
          offset: SCROLL_OFFSET,
          duration: SCROLL_DURATION,
          to: 'scrollTop-more-about',
        }}
      >
        <Element id={'scrollTop-more-about'} />
        <ContentFragment classes="more-info-content">{styledContent}</ContentFragment>
        <Link to="/used-cheap-cars-for-sale/" className="d-block mb-1">
          Shop by price point and browse used cheap cars for sale different cities and states throughout the United
          States.
        </Link>
        <Link to="/new-cars-for-sale/" className="d-block mb-1_5">
          Check out new cars, trucks and SUVs for sale here.
        </Link>
        <Faq
          wrapperType={WRAPPER_TYPES.accordion}
          {...transformContentForFaq(faqContent)}
          pathname={pathname}
          generateLearnMoreLinks
        />
      </ContentCollapse>
    </div>
  );
}

MoreInfoSection.propTypes = {
  content: CmsEntities.Content,
  faqContent: CmsEntities.Content,
  pathname: PropTypes.string,
  className: PropTypes.string,
};
